import { forwardRef } from "react";
import { clsxm } from "@/utils/clsxm";
import { LuCircleArrowRight } from "react-icons/lu";

interface IProps {
  onClick: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  showNextIcon?: boolean;
}

const Button = forwardRef<HTMLButtonElement, IProps>(
  ({ children, className, showNextIcon = true, ...props }, ref) => (
    <div
      className={clsxm(
        "w-auto sticky bottom-0 left-4 right-4 pb-4 pt-8 z-10 pointer-events-none",
        "sm:relative sm:w-full sm:bottom-0 sm:left-0 sm:right-0 sm:px-0 sm:pb-0 sm:pt-0 sm:my-6",
        "bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,#ffffff_31.25%)] sm:bg-transparent"
      )}
    >
      <button
        ref={ref}
        {...props}
        className={clsxm(
          "w-full bg-purple-3 rounded-[48px] text-white text-base font-medium px-4 py-2 min-h-12 flex items-center justify-center gap-2 transition-all duration-300",
          "pointer-events-auto hover:bg-[#53477c]",
          "disabled:cursor-not-allowed disabled:bg-[#9f99b7]",
          className
        )}
      >
        {children || "Next"}
        {showNextIcon && <LuCircleArrowRight />}
      </button>
    </div>
  )
);

export { Button };
